import React, { ComponentPropsWithoutRef } from "react";
import { Tab, TabProps } from "./Tab";

type TabsProps = ComponentPropsWithoutRef<"div"> & {
  children: React.ReactElement<TabProps>[] | React.ReactElement<TabProps>;
  selectedTab: string;
  testid?: string;
  setSelectedTab: (tab: string) => void;
};

export const Tabs = ({
  children,
  selectedTab,
  setSelectedTab,
  className,
  testid,
  ...props
}: TabsProps) => {
  const beforeFilter = React.Children.toArray(children);
  const filteredChildren = beforeFilter.filter(
    (child): child is React.ReactElement<TabProps> =>
      React.isValidElement(child) &&
      child.type === Tab &&
      String(child.props.name).toLocaleLowerCase() ===
        selectedTab.toLocaleLowerCase(),
  );

  const tabs: TabProps[] = beforeFilter
    .map((child) => {
      if (React.isValidElement(child) && child.type === Tab) {
        return {
          name: child.props.name,
          testid: child.props.testid,
          ...(child.props.titleText && {
            titleText: child.props.titleText,
          }),
        };
      }
    })
    .filter((tab) => tab !== undefined);

  return (
    <div
      className={`flex flex-col ${className ?? ""}`}
      {...props}
      data-testid={testid ? `${testid}-tab-container` : undefined}
    >
      <div className="tabs-container flex justify-between" id="menu">
        {tabs.map((tab) => {
          return (
            <div
              data-testid={tab.testid ? `${tab.testid}-tab-header` : undefined}
              key={tab.name}
              onClick={() => setSelectedTab(tab.name)}
              className={`grow h-full ${tab.className ?? ""}
                ${
                  tab.name.toLocaleLowerCase() ===
                  selectedTab.toLocaleLowerCase()
                    ? "tabs-tab-selected"
                    : "tabs-tab-unselected"
                }
              `}
            >
              {tab.titleText ?? tab.name}
            </div>
          );
        })}
      </div>
      <div id="tabContainer">{filteredChildren ?? children}</div>
    </div>
  );
};
